// removed by extract-text-webpack-plugin
module.exports = {"bar":"RatingBar__bar-38MRI","starIcon":"RatingBar__starIcon-3Owxi","star":"RatingBar__star-JvD8s","active":"RatingBar__active-1ulM2","gray":"RatingBar__gray-_2F4h"};